import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import TableComponent from '../../Table/Table';
import axios from 'axios';
import TableComponentPage4 from '../../Table/GroupTable';

function AffliateGroup() {
    const nav = useNavigate()
    const [affGrp, setAffGrp] = useState([])
    const [grpPages, setGrpPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(10)
    const [loading, setLoading] = useState(false)
    const getAffiliateGroup = async () => {
        setLoading(true)
        const response = await axios.get(window.__CFG.API + "affiliates/ListAffiliateGroups?page=" + currentPage, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        setLoading(false)
        if (response.data.Error == null) {
            setAffGrp(response.data.Result.Data)
            setGrpPages(response.data.Result.Pages)
        }
    }
    const columns = React.useMemo(
        () => [
            {
                Header: 'Group ID',
                accessor: 'Id', // accessor is the "key" in the data
            },
            {
                Header: 'Currency',
                accessor: 'Currency',
            },
            {
                Header: '     Name     ',
                accessor: 'Name',
            },
            {
                Header: 'Members',
                accessor: 'Members',
            },

        ],
        []
    );
    useEffect(() => { getAffiliateGroup() }, [grpPages, currentPage])
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    return (
        <>
            <Container>
                <Row className='vh-100'>
                    <Col >

                        <Row className="mt-5 me-4 w-100">

                            <Col lg={3} md={4} sm={5} className=" pt-2" style={{ paddingBottom: 20 }}>
                                <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp"
                                    onClick={() => nav('/affiliate/create-aff-group')}
                                >
                                    Create new group
                                </Button>
                            </Col>
                        </Row>

                        <Row className="mt-0 mb-0">
                            <div className="aff-dash-summary-table">
                                <TableComponent loading={loading} columns={columns} data={affGrp} Pages={grpPages} currentPage={currentPage} onPageChange={handlePageChange} totalPagesView={totalPages} ActionLink={(row) => `/affiliate/affliate-group/details?id=` + row.Id} navigationColumn="Id"  />
                            </div>
                        </Row>




                    </Col>
                </Row>

            </Container>
        </>
    )
}

export default AffliateGroup



